import { render, staticRenderFns } from "./TextSearch.vue?vue&type=template&id=0b569513&scoped=true&"
import script from "./TextSearch.vue?vue&type=script&lang=ts&"
export * from "./TextSearch.vue?vue&type=script&lang=ts&"
import style0 from "./TextSearch.vue?vue&type=style&index=0&id=0b569513&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b569513",
  null
  
)

export default component.exports